// Public Firebase Web config for the Mayday Firebase project (mayday-403709).
// These values are NOT secret — they ship in the client bundle — and are
// shared across all environments. The Web Push VAPID key below is likewise the
// public half of the key pair (see its own note), so it is committed here too.
//
// The same config is mirrored in public/firebase-messaging-sw.js because a
// service worker runs in a separate context and cannot import this module.
export const firebaseConfig = {
  apiKey: 'AIzaSyAOQHeCoJ_AqDqMTHwPH4qLPHE6rvBl-8g',
  authDomain: 'mayday-403709.firebaseapp.com',
  projectId: 'mayday-403709',
  storageBucket: 'mayday-403709.firebasestorage.app',
  messagingSenderId: '1069537621007',
  appId: '1:1069537621007:web:23cab8bc72cd601e4edf7a'
}

// Web Push VAPID public key for the mayday-403709 project. This is the PUBLIC
// half of the Web Push key pair — it is meant to be shipped to browsers, so it
// lives in the committed bundle. The private half stays in Firebase. It is the
// same for every environment since they all use this one Firebase project.
export const vapidKey =
  'BFBG6hsK1bQLRZf9Tel6hUnk1nlagZ00opCku_J-tkkbCBtuiBjyamj3VpxVrTl9AeT7nn-EeId1Ne3FKhaPVjg'
